import { render } from "./GestionPedidos.vue?vue&type=template&id=a5a8ac54&scoped=true"
import script from "./GestionPedidos.vue?vue&type=script&lang=js"
export * from "./GestionPedidos.vue?vue&type=script&lang=js"

import "./GestionPedidos.vue?vue&type=style&index=0&id=a5a8ac54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a8ac54"]])

export default __exports__